module.exports = __webpack_public_path__ + "static/media/plus.ab6e380b.svg";